import { EmailChangeWarning } from './EmailChangeWarning';

export default EmailChangeWarning;
